export default __webpack_public_path__ + "static/media/os4.39fc002b.png";